/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Icon } from '@insticator/insticator-ui'; // iui-material



/* ========== ~~~~~~~~~~ IMAGE UPLOAD : INPUT ~~~~~~~~~~ ========== */
class Input extends Component {
    setActiveSelection = () => {
        if (this.props.cta) {
            this.props.setActiveSelection('none')
        }
    };
    render() {
        let { onSelect, cta } = this.props;
        return (
            <div className={`imagedisplay`}   >
                <input className={`mainImageInput`} onClick={this.setActiveSelection} type="file" onChange={onSelect} />
                {cta && <div className={`imageInput`} >
                    <p>Upload Image</p>
                </div>}
                {!cta && <div className={`imageInput`} >
                    <Icon name={'image'}/>
                    <p>Upload your <br /> own photo</p>
                </div>}
            </div>
        );
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Input;